import { Tag } from "../types";
import React from "react";
import { HiOutlineSparkles } from "react-icons/hi2";
import { parseTransferContent } from "./utils";

interface SummarizationSectionProps {
    stableKey: string;
    tag: Tag;
}

const SummarizationSection: React.FC<SummarizationSectionProps> = ({ stableKey, tag }) => {
    // Display the text from the backend (either "Summarizing data" or "Summarized data")
    const displayText = tag.text || parseTransferContent(tag.content) || 'Summarizing data';

    return (
        <div key={stableKey} className="summarization-section timeline-node">
            <div className="summarization-header">
                <div className="summarization-title">
                    <HiOutlineSparkles className="w-3 h-3" />
                    <span>{displayText}</span>
                    {tag.isStreaming && (
                        <div className="thinking-dots">
                            <div className="thinking-dot" />
                            <div className="thinking-dot" />
                            <div className="thinking-dot" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SummarizationSection;
